/* Variant IDs resolved by handle at render time, with today's IDs as fallback. */
window.BD_GIFT = {
  kitVariant: 56642065301849,
  flagVariant: 42007833641216,
  label: "Gift",
  value: "Free with your Full Custom Graphics Kit"
};
/* ============================================================================
   BD MONEY FORMAT FIX - 2026-08-14  (shipped live in v8)

   formatMoney() in assets/theme-global.js handles only 4 of Shopify's amount
   placeholders and has no default branch, so any other placeholder returns
   the format string with the amount deleted. Sweden uses
   amount_no_decimals_with_space_separator, which rendered as " SEK" on every
   product card once product-card-swatch.min.js booted on idle and overwrote
   the correct server-rendered price. This override covers every placeholder
   plus a safe default. theme-global.js (line 102) and custom.js (line 212)
   are both defer scripts, and defer runs in document order, so this wins.

   This file is Liquid-rendered into assets/custom.js, so the body is wrapped
   in raw tags - otherwise Liquid would strip the very amount placeholders the
   fix exists to handle.
   ========================================================================== */
(function () {
  'use strict';

  function bdAmount(cents, precision, thousands, decimal) {
    if (cents === null || cents === undefined || isNaN(cents)) return '0';
    var parts = (Number(cents) / 100).toFixed(precision).split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }

  function bdFormatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fstr = String(format
      || (window.MinimogSettings && window.MinimogSettings.money_format)
      || '${{amount}}');
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var match = fstr.match(re);
    if (!match) return fstr;

    var value;
    switch (match[1]) {
      case 'amount':                                   value = bdAmount(cents, 2, ',', '.'); break;
      case 'amount_no_decimals':                       value = bdAmount(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator':              value = bdAmount(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator':  value = bdAmount(cents, 0, '.', ','); break;
      case 'amount_with_space_separator':              value = bdAmount(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator':  value = bdAmount(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator':         value = bdAmount(cents, 2, "'", '.'); break;
      case 'amount_with_period_and_space_separator':   value = bdAmount(cents, 2, ' ', '.'); break;
      default:                                         value = bdAmount(cents, 2, ',', '.'); break;
    }
    return fstr.replace(re, value);
  }

  bdFormatMoney.__bdPatched = true;
  window.bdFormatMoney = bdFormatMoney;

  function bdInstallMoneyFix() {
    try {
      if (window.formatMoney && window.formatMoney.__bdPatched) return;
      window.formatMoney = bdFormatMoney;
    } catch (e) {}
  }

  bdInstallMoneyFix();
  document.addEventListener('DOMContentLoaded', bdInstallMoneyFix);
  window.addEventListener('load', bdInstallMoneyFix);
})();

/* ============================================================================
   BD FREE FLAG GIFT - v2, 2026-08-26

   Every Full Custom Graphics Kit ships with a free bold. Flag. The flag is a
   normal line item (not a Shopify bundle - bundles broke the cart price, see
   the money-fix notes) zeroed by the automatic discount "Free bold. Flag with
   Full Custom Graphics Kit". Shopify's Buy X Get Y only discounts Y once it is
   in the cart, it never adds it - that is this script's job.

   v2 CHANGE - the gift is granted ONCE per cart, not continuously enforced.
   v1 reconciled to "kit in cart => gift must exist", so deleting the gift made
   it reappear instantly and the line could not be removed. Now we remember how
   many kits we have already granted for, against the cart token, and:

     kit added, nothing granted yet  -> add flag (qty = kit qty), record grant
     customer deletes the gift       -> LEAVE IT GONE (grant already recorded)
     customer edits the gift qty     -> leave it alone, never fight them
     more kits added than granted    -> top the gift up to match
     kit leaves the cart             -> remove the gift, clear the grant
     kit re-added later              -> fresh grant, gift comes back
     flag out of stock               -> skip quietly, never block the kit

   The grant lives in localStorage keyed by the cart token, so it survives page
   loads and extra tabs, resets by itself when Shopify issues a new cart, and
   never appears on the order (a cart attribute would have shown up there).
   If localStorage is unavailable it degrades to in-memory for the page.

   LOOP GUARD: our own cart calls carry ?bd-gift=1&bd-marker=1. bd-gift makes
   this module ignore its own traffic; bd-marker is a token bd-runtime.js
   already ignores, so injecting the gift does not replay the drawer's
   "item added" open animation.

   Variant IDs come from the Liquid preamble at the top of this file, looked up
   by handle, so renaming a product cannot silently break this.
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.BD_GIFT || {};
  var KIT = Number(CFG.kitVariant || 0);
  var FLAG = Number(CFG.flagVariant || 0);
  var PROP = String(CFG.label || 'Gift');
  var NOTE = String(CFG.value || 'Free with your Full Custom Graphics Kit');
  if (!KIT || !FLAG || KIT === FLAG) return;

  var MARK = 'bd-gift=1&bd-marker=1';
  var STORE_KEY = 'bdGiftGrant';
  var busy = false;
  var rerun = false;
  var blocked = false;              /* flag could not be added (out of stock) */
  var mem = { token: null, granted: 0 };

  function grantedFor(token) {
    try {
      var raw = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
      if (raw && raw.token === token) return Number(raw.granted) || 0;
    } catch (e) {}
    return mem.token === token ? mem.granted : 0;
  }

  function setGranted(token, n) {
    mem = { token: token, granted: n };
    try { localStorage.setItem(STORE_KEY, JSON.stringify(mem)); } catch (e) {}
  }

  function clearGranted() {
    mem = { token: null, granted: 0 };
    try { localStorage.removeItem(STORE_KEY); } catch (e) {}
  }

  function post(url, body) {
    return fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + MARK, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
      return r;
    });
  }

  function finish(refresh) {
    busy = false;
    if (refresh) {
      try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
    }
    if (rerun) { rerun = false; setTimeout(reconcile, 0); }
  }

  function reconcile() {
    if (busy) { rerun = true; return; }
    busy = true;

    fetch('/cart.js?' + MARK, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var token = (cart && cart.token) || '';
        var kitQty = 0;
        var gift = null;

        for (var i = 0; i < items.length; i++) {
          var it = items[i];
          if (Number(it.variant_id) === KIT) kitQty += it.quantity;
          if (Number(it.variant_id) === FLAG && it.properties && it.properties[PROP] === NOTE) gift = it;
        }

        var granted = grantedFor(token);

        /* ---- no kit in the cart ---------------------------------------- */
        if (kitQty === 0) {
          blocked = false;
          if (gift) {
            return post('/cart/change.js', { id: gift.key, quantity: 0 })
              .then(function () {
                clearGranted();
                try { console.info('[BD Gift] kit gone - removed free flag'); } catch (e) {}
                finish(true);
              })
              .catch(function () { finish(false); });
          }
          if (granted) clearGranted();
          return finish(false);
        }

        /* ---- kit present, gift missing --------------------------------- */
        if (!gift) {
          /* Already granted once for this cart => the customer deleted it.
             Respect that; do not put it back. */
          if (granted > 0) return finish(false);
          if (blocked) return finish(false);

          var props = {};
          props[PROP] = NOTE;
          return post('/cart/add.js', { id: FLAG, quantity: kitQty, properties: props })
            .then(function () {
              setGranted(token, kitQty);
              try { console.info('[BD Gift] granted ' + kitQty + ' free flag(s)'); } catch (e) {}
              finish(true);
            })
            .catch(function () {
              blocked = true;
              try { console.info('[BD Gift] flag unavailable - skipped'); } catch (e) {}
              finish(false);
            });
        }

        /* ---- gift present: only ever top up when kits were added -------- */
        if (kitQty > granted && gift.quantity < kitQty) {
          return post('/cart/change.js', { id: gift.key, quantity: kitQty })
            .then(function () {
              setGranted(token, kitQty);
              try { console.info('[BD Gift] topped up to ' + kitQty); } catch (e) {}
              finish(true);
            })
            .catch(function () { finish(false); });
        }

        if (kitQty > granted) setGranted(token, kitQty);
        finish(false);
      })
      .catch(function () { finish(false); });
  }

  window.bdGiftReconcile = reconcile;
  window.bdGiftReset = clearGranted;

  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?/;

  function isOurs(url) { return url.indexOf('bd-gift=1') > -1; }

  /* fetch */
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input) {
      var promise = nativeFetch.apply(this, arguments);
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      if (url && !isOurs(url) && CART_WRITE.test(url)) {
        promise.then(function () { setTimeout(reconcile, 0); }, function () {});
      }
      return promise;
    };
  }

  /* XHR - some apps still post the cart this way */
  try {
    var open = XMLHttpRequest.prototype.open;
    var send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__bdUrl = url || '';
      return open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var u = this.__bdUrl || '';
      if (u && !isOurs(u) && CART_WRITE.test(u)) {
        this.addEventListener('load', function () { setTimeout(reconcile, 0); });
      }
      return send.apply(this, arguments);
    };
  } catch (e) {}

  /* Catch carts restored from a previous session. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(reconcile, 400); });
  } else {
    setTimeout(reconcile, 400);
  }
})();

document.addEventListener('DOMContentLoaded', function () {
  /* BD perf: sticky-atc only exists on product pages, but this file loads
     site-wide and used to run a document-wide MutationObserver forever on
     every page. Now: product template only, observer stops as soon as the
     element is handled, hard stop after 15s. */
  if (document.documentElement.getAttribute('data-template') !== 'product') return;

  var done = false;
  var observer = null;

  function reveal() {
    if (done) return false;
    var stickyATC = document.querySelector('sticky-atc.form.product-form.flex');
    if (!stickyATC) return false;
    stickyATC.style.display = 'flex';
    done = true;
    if (observer) observer.disconnect();
    return true;
  }

  setTimeout(reveal, 1500);

  if (!reveal()) {
    observer = new MutationObserver(function () { reveal(); });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { if (observer) observer.disconnect(); }, 15000);
  }
});
